import { Typography, Box, Button } from "@mui/material";
import { Email, Phone } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
const Help = () => {
    const navigate = useNavigate();
    return (
        <Box
            display="flex"
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
            minHeight="100vh"
            bgcolor="#f8f9e9"
            p={{ xs: 2, sm: 3 }}
        >
            <Box 
                display="flex" 
                flexDirection="column" 
                alignItems="flex-start"  
                width={{ xs: "90%", sm: "80%", md: 600 }}
                p={2}
                border="2px solid #FAD707"
                borderRadius={2}
                bgcolor="#f8f9e9"
                boxShadow={3}
            >
                {/* Heading */}
                <Typography variant="h5" sx={{ fontWeight: "700", color: "#2A289C", mb: 2, fontSize: "24px", textAlign: "center", width: "100%" }}>
                    Having Trouble Logging In?
                </Typography>

                {/* Info Text */}
                <Typography variant="h6" sx={{ fontWeight: 400, color: "#000000", mb: 2, fontSize: "18px", textAlign: "left"}}> 
                    If you are experiencing any issues while logging in, kindly reach out to the appropriate contact for assistance.
                </Typography>

                {/* Super User */}
                <Box display="flex" flexDirection="column" alignItems="flex-start" width="100%">
                    <Typography variant="h6" sx={{ fontWeight: 400, color: "#000000", mb: 1 }}> 
                        Super User
                    </Typography>
                    <Box display="flex" alignItems="center">
                        <Email sx={{ color: "#E52029", mr: 1 }} /> tsct041224@gmail.com
                    </Box>
                    <Box display="flex" alignItems="center" mt={1}>
                        <Phone sx={{ color: "#E52029", mr: 1 }} /> +91 9841818740
                    </Box>
                </Box>

                {/* Admin */}
                <Box display="flex" flexDirection="column" alignItems="flex-start" width="100%" mt={3}>
                    <Typography variant="h6" sx={{ fontWeight: 400, color: "#000000", mb: 1 }}> 
                        Admin
                    </Typography>
                    <Box display="flex" alignItems="center">
                        <Email sx={{ color: "#E52029", mr: 1 }} /> tsct041224@gmail.com
                    </Box>
                    <Box display="flex" alignItems="center" mt={1}>
                        <Phone sx={{ color: "#E52029", mr: 1 }} /> +91 9841818740
                    </Box>
                </Box>
            </Box>

            {/* Footer Message */}
            <Box mt={3}>
                <Typography>
                    Reach out to us for quick support!
                </Typography>
            </Box>
            {/* Back to Login Button */}
            <Button 
                    variant="contained" 
                    sx={{ backgroundColor: "#1E6BB8", 
                        '&:hover': { backgroundColor: "#1E6BB8" },
                        mt:2
                     }}
                     onClick={() => {
                        navigate("/login");
                        window.scrollTo(0, 0);
                    }}
                >
                    Back to Login
                </Button>
        </Box>
    );
};

export default Help;
